import { rolesWithoutAccess } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'

export const isUserHasAccess = (userRoles: string[]) => {
  return !userRoles.find((el) => rolesWithoutAccess.includes(el))
}
